import React from 'react';
import { i18n } from 'config/locales';

import Textarea from 'components/Form/Textarea';
import Field from 'components/Form/Field';
import ContinuingBenefit from './ContinuingBenefit';
import ValidationElement, {
  ValidationElementProps,
} from '../../../../Form/ValidationElement/ValidationElement';
import {
  CommonOnUpdate,
  CommonOnError,
  CommonScrollIntoView,
  CommonRequired,
} from '../../../../../types/props';
import {
  ForeignActivitiesBenefitTypeOtherItemModel,
  ForeignActivitiesBenefitTypeItemModel,
} from '../../../../../forms/sections/foreign/activities/benefits/types';

interface Props
  extends Partial<ForeignActivitiesBenefitTypeOtherItemModel>,
    ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  scrollIntoView?: CommonScrollIntoView
  attribute?: string
  otherBenefit?: ForeignActivitiesBenefitTypeItemModel
}

export default class OtherBenefit extends ValidationElement<Props> {
  updateOtherFrequencyTypeExplanation = (
    values: ForeignActivitiesBenefitTypeOtherItemModel['OtherFrequencyTypeExplanation']
  ) => {
    this.props.onUpdate({
      ...this.props.otherBenefit,
      OtherFrequencyTypeExplanation: values,
    });
  };

  updateOtherBenefit = (values: ForeignActivitiesBenefitTypeOtherItemModel['OtherBenefit']) => {
    this.props.onUpdate({
      OtherFrequencyTypeExplanation: this.props.OtherFrequencyTypeExplanation,
      ...this.props.otherBenefit,
      ...values,
    });
  };

  render() {
    return (
      <div>
        {i18n.m('foreign.activities.benefit.label.otherBenefit')}
        <Field attribute={`${this.props.attribute}.OtherFrequencyTypeExplanation`}>
          <Textarea
            name="OtherFrequencyTypeExplanation"
            {...this.props.otherBenefit.OtherFrequencyTypeExplanation}
            onUpdate={this.updateOtherFrequencyTypeExplanation}
            onError={this.props.onError}
            required={this.props.required}
            attribute={`${this.props.attribute}.OtherFrequencyTypeExplanation`}
          />
        </Field>
        {/* Hacky spacer between components */}
        <div style={{ height: '30px' }} />
        {/* The 'Other' frequency type has the same fields as the ConinuingBenefit */}
        <ContinuingBenefit
          name="OtherBenefit"
          {...this.props.otherBenefit}
          onUpdate={this.updateOtherBenefit}
          onError={this.props.onError}
          required={this.props.required}
          scrollIntoView={this.props.scrollIntoView}
          attribute={this.props.attribute}
        />
      </div>
    );
  }
}

OtherBenefit.defaultProps = {
  otherBenefit: {},
  required: false,
  scrollIntoView: () => {},
};
